import React from "react";
import { Stack } from "expo-router";
import { MobileHeader } from "@/screens/menu/mobile.header";
import { useMobileBreakpoint } from "@/utils/useMobileBreakpoint";

export default function RestaurantsLayout() {
  const breakpoint = useMobileBreakpoint();

  return (
    <MobileHeader>
      <Stack.Screen
        name="index"
        options={{ headerShown: breakpoint === "mobile", title: "Business" }}
      />
    </MobileHeader>
  );
}
